import { registerBrick, BrickContext } from 'olympe';
import { ReactBrick } from '@olympeio/core';
import React from 'react';
import { Paper, IconButton, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export default class AdvancedSearch extends ReactBrick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<*>} properties
     * @returns {Element}
     */

    static getReactComponent($) {
        return (props) => {
            return (
                <Paper
                    component="form"
                    sx={{
                        p: '2px 4px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        width: '70%',
                        backgroundColor: 'rgb(250,250,250)',
                        cursor: 'pointer !important',
                    }}
                >
                    <IconButton
                        className={'base-popup-button'}
                        aria-label="search"
                        onClick={() => {
                            $.trigger('Trigger Popup');
                        }}
                    >
                        <Typography>Advanced search</Typography>
                        <SearchIcon />
                    </IconButton>
                </Paper>
            );
        };
    }
}

registerBrick('017f888e3a741bb9f8c0', AdvancedSearch);
